import React, { memo } from "react";
import TransitToggle from "./TransitToggle";
import DaysBadge from "./DaysBadge";

const TransitItemRow = memo(({ item, catalogItem, onToggle }) => {
  return (
    <div className="bg-white p-3 rounded-lg border border-slate-200 shadow-sm flex items-center gap-3 hover:shadow-md transition-all">
      <TransitToggle order={item} onToggle={onToggle} />

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="font-mono font-bold text-blue-600 text-sm">
            {item.sku}
          </span>
          <DaysBadge date={item.customCreatedAt || item.createdAt} order={item} />
        </div>
        <p className="text-xs text-slate-500 truncate">
          {catalogItem?.name || "Produto sem nome"}
        </p>
        <p className="text-[10px] text-slate-400 font-bold uppercase mt-1">
          {item.order?.customer?.name || "Cliente Balcão"}
          {item.order?.number && (
            <span className="ml-1">#{item.order.number}</span>
          )}
        </p>
      </div>

      <div className="text-right">
        <span className="text-[10px] font-bold px-2 py-1 rounded bg-slate-100 text-slate-600 uppercase border border-slate-200">
          {item.status}
        </span>
      </div>
    </div>
  );
}, (prev, next) => {
  return prev.item.transit_status === next.item.transit_status && prev.item.updated === next.item.updated;
});

export default TransitItemRow;
